<div id="images_renderer" class="d-flex h-100 w-100 padding_2px images_renderer">
    <img class="h-100 w-100 p-1 d-flex justify-content-center align-items-center cursor-pointer images_renderer" [src]="displayImage??''" alt="Img" srcset="" onerror="this.src = './assets/svg/no_image_available.svg'">
</div>
